/***
 * @file:
 * @author: caojianping
 * @Date: 2021-03-08 09:39:36
 */
import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';

import { PlacementType } from './pcp-theme-user-panel/pcp-theme-user-panel.component';

@Component({
  selector: 'dt-pcp-theme-user',
  templateUrl: './pcp-theme-user.component.html',
  styleUrls: ['./pcp-theme-user.component.scss'],
})
export class PcpThemeUserComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() placement: PlacementType;
  @Input() top: number;

  panelEvent: Subscription;

  fullName = '';
  firstName = '';
  visible = false;

  constructor(private settingSrv: SettingsService) {
    const user = this.settingSrv.user;
    const name = user ? user.personName : '';
    this.fullName = name || '';
    this.firstName = (name || '').slice(0, 1);
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.bindPanelEvent();
  }

  ngOnDestroy(): void {
    if (this.panelEvent) {
      this.panelEvent.unsubscribe();
      this.panelEvent = null;
    }
  }

  // è®¢éé¢æ¿äºä»¶
  bindPanelEvent() {
    const self = this;
    if (self.panelEvent) {
      return;
    }

    self.panelEvent = fromEvent(document, 'click').subscribe((event: any) => {
      const userElem = document.querySelector('.pcp-theme-user');
      if (userElem) {
        if (!userElem.contains(event.target)) {
          self.visible = false;
        }
      }
    });
  }

  openPanel() {
    this.visible = true;
  }

  closePanel() {
    this.visible = false;
  }
}
